export interface ProductoPostGrado{
    iddecinvproductoprogramapostgrado: number,
    iddecinvproyectoprodtermin: number,
    espol: string,
    idprograma: number,
    nombreprograma: string,
    instituciontitular: string
}

export function GetVoidProductoPostGrado(): ProductoPostGrado{
    return{
        iddecinvproductoprogramapostgrado: 0,
        iddecinvproyectoprodtermin: 0,
        espol: 'N',
        idprograma: 0,
        nombreprograma: "",
        instituciontitular: ""
    }
}

export function setProductoPostGrado(row: any): ProductoPostGrado{
    return{
        iddecinvproductoprogramapostgrado: row.iddecinvproductoprogramapostgrado??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        espol: row.espol??'N',
        idprograma: row.idprograma??0,
        nombreprograma: row.nombreprograma??"",
        instituciontitular: row.instituciontitular??""
    }
}